import * as React from "react";
import new_user from "../images/newuser.jpg";

const LogoutScreen: React.FC = () => {
  
  return (
    <div>
      <br />
      <div className="inline">
        <img src={new_user} width="180" height="114" alt=""></img>
      </div>
      <div style={{ marginLeft: "200px" }}>
        <div>Thank you, you have been logged off.</div>
        <div>
          The cookie used to automatically logyou in has been removed from your
          browser. If you accidently came to this page and want to be logged in,
          please enter your e-mail address and your password in the login box in
          the right column.
        </div>
        <div>If you want to change your password, click here.</div>
        <div>If you do not have an account yet, click here.</div>
      </div>
    </div>
  );
};

export default LogoutScreen;